
// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
  Button
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useAccount } from "flow/flowContext";
import { useEffect, useState } from "react";
import { getAccountData } from "flow/scripts/account";
import ContractsManagerHeader from "components/Headers/ContractsManagerHeader";

const ContractsManager = () => {

  const { address, isConnected, disconnect, connect } = useAccount();
  const [accountData, setAccountData] = useState(null);


  const fetchAccountData = async () =>{
    const accountData = await getAccountData(address)
    setAccountData(accountData)
  }

  useEffect(() => {
    fetchAccountData()
  }, [])



  return (
    <>
      <ContractsManagerHeader accountData={accountData}/>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Contracts</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Contract Name</th>
                    <th scope="col">Size</th>
                    <th scope="col">View Code</th>
                    
                  </tr>
                </thead>
                <tbody>
                {accountData && accountData.contracts.map((contract) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {contract.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{new Blob([contract.code]).size/1024} &nbsp; KB</td>
                    <td>
                        <Button color="primary" size="sm" href={URL.createObjectURL(new Blob([contract.code]))} target="_blank">View</Button>
                    </td>
                   
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
        {/* Dark table */}
       
      </Container>
    </>
  );
};
export default ContractsManager;
